import { paymentConstants } from "./types";
import { alertActions, loading } from "../alert/actions";
import { beginLogout } from "../login/actions";
import { addPayment, getPayments, cancelPayment, getActiveMemberNumbers, getPaymentSummary, getActiveMemberNoLists } from "../../../services/payment.service";

const endError = (error, payment) => {
  return dispatch => {
    if (error?.response?.status === 401 || error?.message === "Network Error") {
      dispatch(beginLogout());
    }
    else {
      dispatch(alertActions.error(error));
      dispatch({
        type: paymentConstants.PAYMENT_ERROR,
        error,
        payload: { payment }
      });
    }
  }
}
const getActiveMemberNumber = () => {
  return async (dispatch) => {
    try {
      const res = await getActiveMemberNumbers();
      dispatch(endMemberNumber(res.data));
    } catch (error) {
      dispatch(endError(error));
    }
  };
};

const endMemberNumber = (data) => ({
  type: paymentConstants.GET_ACTIVE_MEMBER_NUMBER,
  payload: { paymentActiveMemberNumbers: data },
});

const getActiveMemberNoList = (paymentType) => {
  return async (dispatch) => {
    try {
      const res = await getActiveMemberNoLists(paymentType);
      dispatch(endMemberNoList(res.data));
    } catch (error) {
      dispatch(endError(error));
    }
  };
};
const endMemberNoList = (data) => ({
  type: paymentConstants.GET_ACTIVE_MEMBER_NOLIST,
  payload: { paymentActiveMemberNoListData: data },
});

const createPayment = (orderPayment, currPage, nextPage) => {
  return dispatch => {
    dispatch(request(orderPayment));
    dispatch(loading.showLoading());
    addPayment(orderPayment).then(
      payment => {
        orderPayment.sms.gsm = payment.data.maskedGsmNo;
        dispatch(success(orderPayment));
        dispatch(loading.hideLoading());
      },
      error => {
        dispatch(endError(error, orderPayment));
        dispatch(loading.hideLoading());
      }
    );
  };


  function request(payment) {
    payment.page = currPage;
    return {
      type: paymentConstants.ADD_PAYMENT_REQUEST,
      payload: {
        payment,
        page: currPage
      }
    };
  }
  function success(payment) {
    payment.page = nextPage;
    if (payment.sms.sms == null || payment.sms.sms == "") {
      return { type: paymentConstants.ADD_PAYMENT_SMS, payload: { payment, page: nextPage } };
    }
    else {
      return { type: paymentConstants.ADD_PAYMENT_SUCCESS, payload: { payment, page: nextPage } };
    }
  }
}


const createPaymentPayFor = (orderPayment, currPage, nextPage) => {
  return dispatch => {
    dispatch(request(orderPayment));
    dispatch(loading.showLoading());
    addPayment(orderPayment).then( 
      response => { 
        dispatch(success(orderPayment,response));
        dispatch(loading.hideLoading());
      },
      error => {
        dispatch(endError(error, orderPayment));
        dispatch(loading.hideLoading());
      }
    );
  };


  function request(payment) {
    payment.page = currPage;
    return {
      type: paymentConstants.ADD_PAYMENT_REQUEST,
      payload: {
        payment,
        page: currPage
      }
    };
  }
  function success(payment , response) { 
    payment.page = nextPage;
    // if (payment.sms.sms == null || payment.sms.sms == "") {
    //   return { type: paymentConstants.ADD_PAYMENT_SMS, payload: { payment, page: nextPage } };
    // }
    // else {
      return { type: paymentConstants.ADD_PAYMENT_SMS, payload: { payment, page: nextPage, response: response } };
    // }
  }
}

const clearPaymentList = () => {
  return dispatch => {
    dispatch(clear());
  };
  function clear() {
    return {
      type: paymentConstants.PAYMENT_LIST_SUCCESS,
      payload: { paymentList: null }
    };
  }
}

const getPaymentList = (uyeNo, startDate, endDate) => {
  return dispatch => {
    dispatch(request());
    dispatch(loading.showLoading());
    getPayments(uyeNo, startDate, endDate).then(
      response => {
        dispatch(success(response.data));
        dispatch(loading.hideLoading());
      },
      error => {
        dispatch(endError(error));
        dispatch(loading.hideLoading());
      }
    );
  };
  function request() {
    return {
      type: paymentConstants.PAYMENT_LIST_REQUEST,
      payload: {}
    };
  }
  function success(data) {
    return {
      type: paymentConstants.PAYMENT_LIST_SUCCESS,
      payload: { paymentList: data }
    };
  }
};
const getPaymentSum = (uyeNo) => {
  return dispatch => {
    dispatch(request());
    dispatch(loading.showLoading());
    getPaymentSummary(uyeNo).then(
      response => {
        dispatch(success(response.data));
        dispatch(loading.hideLoading());
      },
      error => {
        dispatch(endError(error));
        dispatch(loading.hideLoading());
      }
    );
  };
  function request() {
    return {
      type: paymentConstants.PAYMENT_SUMMARY_REQUEST,
      payload: {}
    };
  }
  function success(data) {
    return {
      type: paymentConstants.PAYMENT_SUMMARY_SUCCESS,
      payload: { paymentSumData: data }
    };
  }
};
const getPaymentDetail = (uyeNo, paymentId) => {
  return dispatch => {
    dispatch(request());
    dispatch(loading.showLoading());
    getPaymentDetail(uyeNo, paymentId).then(
      response => {
        dispatch(success(response.data));
        dispatch(loading.hideLoading());
      },
      error => {
        dispatch(endError(error));
        dispatch(loading.hideLoading());
      }
    );
  };
  function request() {
    return {
      type: paymentConstants.PAYMENT_LIST_REQUEST,
      payload: {}
    };
  }
  function success(data) {
    return {
      type: paymentConstants.PAYMENT_LIST_SUCCESS,
      payload: { paymentList: data }
    };
  }
};

const deletePayment = (uyeNo, paymentId, itemStartDate, startDate, endDate,isPayforPayment) => {
  return dispatch => {
    dispatch(request());
    dispatch(loading.showLoading());
    cancelPayment(uyeNo, paymentId, itemStartDate,isPayforPayment).then(
      response => {
        dispatch(success(response.data));
        dispatch(loading.hideLoading());
        dispatch(getPaymentList(uyeNo, startDate, endDate));
        dispatch(
          alertActions.success("Talimat iptali gerçekleştirilmiştir.")
        );
      },
      error => {
        dispatch(endError(error));
        dispatch(loading.hideLoading());
      }
    );
  };
  function request() {
    return {
      type: paymentConstants.CANCEL_PAYMENT_REQUEST,
      payload: {}
    };
  }
  function success(data) {
    return {
      type: paymentConstants.CANCEL_PAYMENT_SUCCESS,
      payload: { paymentList: data }
    };
  }
};
// const clearSuccessMessageLoyalty = () => {
//   return {
//     type: paymentConstants.CLEAR_SUCCESS_MESSAGE,
//     payload: {  }
//   };
// };
const changeCurrentPage = (page) => {
  return {
    type: paymentConstants.CHANGE_PAGE,
    payload: { page: page }
  };
}
export { createPayment, createPaymentPayFor, getPaymentList, getPaymentDetail, deletePayment, changeCurrentPage, getActiveMemberNumber, getPaymentSum, getActiveMemberNoList, clearPaymentList };
